<template>
  <div id="lemontreeSnb" role="navigation" class="snb_lemontree" @click.self="onClickClose()">
    <div class="inner_snb">
      <div class="user_lemontree">
        <button class="btn_user" @click="onClickUser()">
          <span class="img_profile">
            <!-- 이미지 리사이징 및 base64 변환용 canvas -->
            <canvas id="canvas"></canvas>
          </span>
          <span class="txt_user">
            <span class="user_name">
              <Badge
                v-if="$commonData.isSnbRoleBadge"
                :text="getUserData.role | convertIdToText('member_role')"
                :badgeStyle="getUserData.role | convertIdToColor('member_role')"
                badgeSize="xsmall"
                :badgeFill="false" />
              <span class="txt_name">{{ getUserData.name || '-' }}</span>
            </span>
            <span class="txt_email">{{ getUserData.email }}</span>
          </span>
          <!-- <span v-if="getUserData.loginStatus === 'NEED_MFA'" class="txt_alarm">⚠️ MFA를 설정해주세요</span> -->
        </button>
      </div>
      <div class="area_menu">
        <SnbList
          v-for="(serviceMenu, index) in menuDataList"
          :key="serviceMenu.title"
          :serviceMenu="serviceMenu"
          :index="index"/>
      </div>
      <div class="area_bottom"></div>
    </div>
  </div>
</template>

<script>
import { menuData } from '@/constants/menuData';
import Badge from '@lemontree-ai/lemontree-admin-common-front/components/common/badge/Badge';
import SnbList from '@lemontree-ai/lemontree-admin-common-front/components/layout/header/SnbList'
import IconSvg from '@lemontree-ai/lemontree-admin-common-front/components/common/icon/IconSvg';
import { mapGetters, mapActions } from 'vuex';
import { checkRequiresRoleLevel } from '@lemontree-ai/lemontree-admin-common-front/utils/validateUtils';

export default{
  name:'Snb',
  components:{
    Badge,
    SnbList,
    IconSvg
  },
  mounted(){
    this.setImgResize();
  },
  data(){
    return{
      resizingSize:68,
      hoverSnb:{},
    }
  },
  computed:{
    ...mapGetters('commonUserData', [ 'getUserData', 'getUserRole' ]),
    menuDataList(){
      let menuDataSync = JSON.parse(JSON.stringify(menuData));
      return this.setMenuRequiresRole(menuDataSync)
    },
  },
  methods:{
    ...mapActions('commonGnb', [ 'fetchGnbAction' ]),
    ...mapActions('commonUserData', [ 'fetchUserResizeImg' ]),
    setImgResize(){
      var canvas = document.getElementById("canvas");
      var ctx = canvas.getContext("2d");
      var img = new Image;
      var _this = this;
      img.onload = function() {
        var iw = img.width;
        var ih = img.height;
        var scale = Math.min((_this.resizingSize/iw),(_this.resizingSize/ih));
        var iwScaled = iw*scale;
        var ihScaled = ih*scale;
        canvas.width = iwScaled;
        canvas.height = ihScaled;
        ctx.drawImage(img,0,0,iwScaled,ihScaled);
        // var base64Url = canvas.toDataURL("image/jpeg",1);
        // _this.fetchUserResizeImg(base64Url)
      }
      img.src = this.getUserData.image || 'https://admin.lemontree.ai/assets/images/profile_default.png';
      // img.src = 'https://lt-admin-public.s3.ap-northeast-2.amazonaws.com/images/admins/profile_hari.png';
    },
    onClickUser(){
      this.$router.push({ name: 'MY' });
    },
    onClickClose(){
      this.fetchGnbAction(false);
    },
    setMenuRequiresRole(menuData){
      let result = menuData.filter(menu => checkRequiresRoleLevel(menu.requiresMinRole,this.getUserRole));
      // isOnlyDev
      const isProductionMode = process.env.NODE_ENV === 'production';
      if(isProductionMode){
        result = result.filter(menu => !menu.isOnlyDev);
      }
      result = result.map(menuItem => {
        let rObj = menuItem;
        if(menuItem.menuList && menuItem.menuList.length > 0){
          rObj.menuList = this.setMenuRequiresRole(menuItem.menuList)
        }
        return rObj;
      })
      return result;
    }
  }
}
</script>

<style lang="scss" scoped>
.snb_lemontree{position:fixed;overflow:hidden;top:51px;bottom:0;left:0;z-index:100;background-color:$DIMMED_BG;color:#555;white-space:nowrap;backdrop-filter:blur(2px);box-shadow:0 2px 8px rgba(0,0,0,.04)}
.snb_lemontree .inner_snb{display:flex;flex-direction:column;height:100%;background-color:$ACTIVE_BG}
/* snb - logo */
// .snb_lemontree .tit_logo{padding:14px;line-height:32px;border-bottom:1px solid $DEFAULT_BORDER}
// .snb_lemontree .tit_logo .img_logo{display:inline-block;width:32px;height:32px;vertical-align:top}
// .snb_lemontree .tit_logo .txt_logo{padding:6px 0 0 16px;font-weight:700;font-size:24px;line-height:26px;letter-spacing:-0.02em}
/* snb - user */
.snb_lemontree .user_lemontree{line-height:34px}
.snb_lemontree .user_lemontree:after{display:block;visibility:hidden;height:0;font-size:0;clear:both;content:''}
.snb_lemontree .user_lemontree .btn_user{display:block;width:100%;padding:8px;text-align:left}
.snb_lemontree .user_lemontree .btn_user:hover{background-color:rgba($PRIMARY_COLOR,.2)}
.snb_lemontree .user_lemontree .img_profile{float:left;overflow:hidden;width:33px;height:33px;border-radius:100%;border:1px solid $DEFAULT_BORDER}
.snb_lemontree .user_lemontree .txt_user{overflow:hidden;max-width:calc(100% - 54px);margin:0 0 0 10px;color:#555}
.user_name{display:inline-block;overflow:hidden;max-width:100%;height:18px;vertical-align:top}
.user_name .badge_comm{float:right;margin-left:4px}
.user_name .txt_name{display:block;overflow:hidden;font-weight:700;font-size:14px;line-height:18px;white-space:nowrap;text-overflow:ellipsis}
.txt_alarm{display:block;margin-top:8px;padding:6px 10px 4px;border:1px solid #FF7043;border-radius:4px;font-weight:700;font-size:12px;line-height:14px;color:#FF7043;background-color:#FF704320}
.txt_email{display:block;overflow:hidden;font-weight:600;font-size:12px;line-height:14px;white-space:nowrap;text-overflow:ellipsis;color:#888}
/* snb - snb */
.snb_lemontree .area_menu{overflow:hidden;overflow-y:auto;flex-grow:1}
.snb_lemontree .area_menu::-webkit-scrollbar{width:6px;height:6px;background-color:#fff} /* 스크롤 바 전체 너비 */
/* close btn */
.btn_close{position:absolute;top:0;left:270px;width:60px;height:60px}

/* #canvas{display:inline-block;position:absolute;top:0;right:0;z-index:10;width:0;height:0;opacity:0.01;filter:alpha(opacity=1);} */
#canvas{display:block;width:33px;height:33px}


@media (prefers-color-scheme: dark) {
  .snb_lemontree{color:#fff}
  .snb_lemontree .inner_snb{background-color:$ACTIVE_BG_DARK}
  .snb_lemontree .tit_logo{border-bottom-color:$DEFAULT_BORDER_DARK}
  .snb_lemontree .user_lemontree{border-bottom-color:$DEFAULT_BORDER_DARK}
  .snb_lemontree .user_lemontree .img_profile{border-color:$DEFAULT_BORDER_DARK}
  .snb_lemontree .user_lemontree .txt_user{color:#eee}
  .snb_lemontree .area_menu::-webkit-scrollbar{background-color:#222} /* 스크롤 바 전체 너비 */
}
</style>